import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { goTo } from '../../../actions';
import BigButton from '../../../components/BigButton';
import { HOME_PAGE } from '../../../constants';

class TryItButton extends React.Component {

  onClick = () => {
    this.props.goTo(HOME_PAGE)
  };

  render() {
    return <BigButton
      text="TRY IT FREE"
      onClick={this.onClick}
    />;
  }
}

TryItButton.propTypes = {};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    goTo
  }, dispatch)
}


TryItButton = connect(
  null,
  mapDispatchToProps
)(TryItButton);


export default TryItButton;



// WEBPACK FOOTER //
// ./src/containers/Buttons/TryItButton/index.js